<template>
  <v-navigation-drawer
    width="100%"
    fixed
    app
    floating
    :expand-on-hover="mini"
    :value="drawer"
    :right="$vuetify.rtl"
    class="my-4 ms-4 border-radius-lg"
    :class="!$vuetify.breakpoint.mobile ? '' : 'bg-white'"
    :data-color="sidebarColor"
    :data-theme="sidebarTheme"
  >
    <template v-if="$store.state.userData">
      <div class="d-flex flex-row">
        <v-avatar rounded :size="36" class="my-0 me-5">
          <v-img
            :alt="require('@/assets/img/team-2.jpg')"
            :src="require('@/assets/img/team-2.jpg')"
            class="border-radius-lg"
          ></v-img>
        </v-avatar>
        <p class="font-weight-bold" v-if="$store.state.userData != null">
          <span @click="_print">Сайн байна уу? </span>

          <br />
          <template v-if="$store.state.userData.role == 'teacher'">
            {{ $store.state.userData["DISPLAY_NAME"] }}
          </template>
          <template v-if="$store.state.userData.role == 'student'">
            {{ $store.state.userData["LAST_NAME"][0] }}.{{
              $store.state.userData["FIRST_NAME"]
            }}
          </template>
          <!-- <span class="text-secondary">({{ $store.state.userData.ref.path }})</span> -->
        </p>
      </div>
      <p @click="_print" class="text-center mb-0">
        {{ $store.state.userData.email }}
      </p>
      <p
        class="blue--text text-center mb-0"
        v-if="$store.state.userData.school"
      >
        <span v-if="userData.role != 'citymanager'">
          {{ userData.school.name }}
        </span>
        <span v-if="userData['ACADEMIC_ORG_NAME']"
          >, {{ userData["ACADEMIC_ORG_NAME"] }}</span
        >
      </p>
      <hr class="horizontal dark mb-0" />
      <p class="text-center mb-0">{{ userData["USERNAME"] }}</p>
      <p v-if="$store.state.userData.role == 'superadmin'">
        {{ $store.state.userData.ref.path }}
      </p>
      <v-select
        v-if="
          $store.state.availableSchools &&
          ($store.state.userData.role == 'superadmin' ||
            $store.state.userData.role == 'citymanager')
        "
        :items="$store.state.availableSchools"
        item-text="name2"
        item-value="ref.path"
        v-model="selectedSchool"
        clearable
        label="Сургуулиа сонгох"
      >
        <template v-slot:selection="{ item }">
          {{ item.name2 }}
        </template>
      </v-select>
      <hr class="horizontal dark mb-4" />
    </template>
    <v-list nav dense>
      <v-list-group
        :ripple="false"
        v-for="menuItem in menues"
        :key="menuItem.title"
        v-model="menuItem.active"
        append-icon="fas fa-angle-down"
        class="pb-1 ml-0 mr-2 pl-0"
        active-class="item-active"
      >
        <template v-slot:activator>
          <v-list-item-icon class="shadow border-radius-md mx-2 align-center">
            <div v-html="menuItem.action">
              {{ menuItem.action }}
            </div>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              v-text="menuItem.title"
              class="ms-1"
            ></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          :ripple="false"
          link
          class="mb-0 no-default-hover ml-0 pl-1"
          v-for="child in menuItem.items"
          :key="child.title + '-' + child.id"
          :to="child.link"
        >
          <span class="v-list-item-mini" v-text="child.prefix"></span>
          <v-list-item-content class="ms-2 ps-4" v-if="!child.items">
            <v-list-item-title v-if="child.isNew" @click="listClose($event)">
              {{ child.title }}
              <small
                style="
                  padding-left: 2px;
                  padding-right: 2px;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  color: white;
                  background-color: red;
                  font-weight: normal;
                  border-radius: 3px;
                  font-size: 8pt;
                "
                >New</small
              >
            </v-list-item-title>
            <v-list-item-title
              v-else-if="child.isUpdated"
              @click="listClose($event)"
            >
              {{ child.title }}
              <small
                style="
                  padding-left: 2px;
                  padding-right: 2px;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  color: white;
                  background-color: blue;
                  font-weight: normal;
                  border-radius: 3px;
                  font-size: 8pt;
                "
                >Шинэчилсэн</small
              >
            </v-list-item-title>

            <v-list-item-title
              v-else-if="child.isTest"
              @click="listClose($event)"
            >
              {{ child.title }}
              <small
                style="
                  padding-left: 2px;
                  padding-right: 2px;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  color: black;
                  background-color: yellow;
                  font-weight: normal;
                  border-radius: 3px;
                  font-size: 8pt;
                "
                >Туршилт</small
              >
            </v-list-item-title>

            <v-list-item-title
              v-else
              v-text="child.title"
              @click="listClose($event)"
            >
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content class="ms-6 ps-7 py-0" v-if="child.items">
            <v-list-group
              prepend-icon=""
              :ripple="false"
              sub-group
              no-action
              v-model="child.active"
            >
              <template v-slot:activator>
                <span class="v-list-item-mini">{{ child.prefix }}</span>
                <v-list nav dense class="pa-0">
                  <v-list-group
                    :ripple="false"
                    append-icon="fas fa-angle-down me-auto ms-1"
                    active-class="item-active"
                    class="mb-0"
                  >
                    <template v-slot:activator class="mb-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-title
                          v-text="child.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-group>
                </v-list>
              </template>
              <v-list-item
                v-for="child2 in child.items"
                :ripple="false"
                :key="child2.title"
                :to="child2.link"
                @click="listClose($event)"
              >
                <span class="v-list-item-mini" v-text="child2.prefix"></span>
                <v-list-item-content>
                  <v-list-item-title v-text="child2.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <template v-if="userData && userData.role == 'superadmin'">
        <v-list-group
          :ripple="false"
          v-for="menuItem in settingMenus"
          :key="menuItem.title"
          v-model="menuItem.active"
          append-icon="fas fa-angle-down"
          class="pb-1 mx-2"
          active-class="item-active"
        >
          <template v-slot:activator>
            <v-list-item-icon class="shadow border-radius-md mx-2 align-center">
              <div v-html="menuItem.action">
                {{ menuItem.action }}
              </div>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="menuItem.title"
                class="ms-1"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            :ripple="false"
            link
            class="mb-0 no-default-hover"
            :class="child.active ? 'item-active' : ''"
            v-for="child in menuItem.items"
            :key="child.title"
            :to="child.link"
          >
            <span class="v-list-item-mini" v-text="child.prefix"></span>

            <v-list-item-content class="ms-6 ps-7" v-if="!child.items">
              <v-list-item-title
                v-text="child.title"
                @click="listClose($event)"
              ></v-list-item-title>
            </v-list-item-content>

            <v-list-item-content class="ms-6 ps-7 py-0" v-if="child.items">
              <v-list-group
                prepend-icon=""
                :ripple="false"
                sub-group
                no-action
                v-model="child.active"
              >
                <template v-slot:activator>
                  <span class="v-list-item-mini">{{ child.prefix }}</span>
                  <v-list nav dense class="pa-0">
                    <v-list-group
                      :ripple="false"
                      append-icon="fas fa-angle-down me-auto ms-1"
                      active-class="item-active"
                      class="mb-0"
                    >
                      <template v-slot:activator class="mb-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title
                            v-text="child.title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-group>
                  </v-list>
                </template>

                <v-list-item
                  v-for="child2 in child.items"
                  :ripple="false"
                  :key="child2.title"
                  :to="child2.link"
                  @click="listClose($event)"
                >
                  <v-list-item-content>
                    <span
                      class="v-list-item-mini"
                      v-text="child2.prefix"
                    ></span>
                    <v-list-item-title
                      v-text="child2.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>

    <v-card
      class="pa-0 border-radius-lg mt-7 mb-9 mx-4"
      :style="`background-image: url(${require('../assets/img/curved-images/white-curved.jpeg')}); background-size: cover;`"
    >
      <span
        class="mask opacity-8 border-radius-lg"
        :class="`bg-gradient-` + sidebarColor"
      ></span>
      <div class="px-4 py-4 position-relative">
        <v-avatar
          color="bg-white"
          class="shadow"
          width="32"
          height="32"
          min-width="32"
          rounded
        >
          <v-icon
            size="20"
            class="text-gradient"
            :class="`text-` + sidebarColor"
          >
            ni ni-diamond
          </v-icon>
        </v-avatar>
        <div class="docs-info">
          <v-card-text
            class="text-white text-h6 ps-0 pb-0"
            @click="_printAllEmails"
            >Тусламж?</v-card-text
          >
          <v-card-subtitle class="text-white text-xs font-weight-bold pt-0 ps-0"
            >Тусламж цэс руу орж заавар видеотой танилцаарай</v-card-subtitle
          >
        </div>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>
<script>
import { sync } from "vuex-pathify";
import { store } from "@/store.js";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ddd",
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    sidebarColor: {
      type: String,
      default: "success",
    },
    sidebarTheme: {
      type: String,
      default: "transparent",
    },
  },

  data: () => ({
    schoolMealAppMenu: null,
    schoolAppOthers: null,
    schoolAppSorils: null,
    schoolAppMainRegistration: null,
    schoolAppMyClass: null,
    mini: false,
    togglerActive: false,
    items: null,
    menues: null,
    settingMenus: null,
    selectedSchool: store.state.selectedSchoolRef,
  }),
  computed: {
    ...sync("*"),
  },
  watch: {
    userData() {},
    selectedSchool(val) {
      store.set("selectedSchoolRef", val);
      console.log(store.state.selectedSchoolRef);
      if (this.$route.path != "/pages/dashboards/default")
        this.$router.replace("/").then(() => {
          location.reload();
        });
      else location.reload();
    },
  },
  created() {
    this.menues = [];
    var homeMenues = [];
    this.settingMenus = [
      {
        title: "Нүүр xуудас",
        prefix: "D",
        link: "/pages/dashboards/default",
      },

      // {
      //   title: "XичээлүүдTMP",
      //   prefix: "S",
      //   link: "/pages/dashboards/lessonstmp",
      // },

      // {
      //   title: "Xичээлийн идэвx",
      //   prefix: "A",
      //   link: "/pages/pages/pagelessonactivitychecking",
      // },
      // {
      //   title: "Даалгаврын дүн",
      //   prefix: "A",
      //   link: "/pages/pages/pagelessonhomeworkchecking",
      // },

      // {
      //   title: "Calendar",
      //   prefix: "C",
      //   link: "/pages/dashboards/crm",
      // },
    ];
    if (this.$store.state.userData.role != "student") {
      homeMenues.push(
        ...[
          {
            title: "Мэргэжлийн зэрэг",
            prefix: "S1",
            link: "/bagshiinzereg",
            isNew: true,
          },
          {
            title: "Сургалтын xуваарь",
            prefix: "S1",
            link: "/surgaltiinhuvaari",
            isNew: true,
          },
        ]
      );
    }
    this.schoolAppHome = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Home",
      items: homeMenues,
    };
    this.schoolAppMainRegistration = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Бүртгэл",
      items: [],
      shortName: "others",
    };

    this.schoolAppSorils = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Сорилууд",
      items: [],
      shortName: "others",
    };
    this.schoolAppMyClass = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Миний анги",
      items: [],
    };

    this.schoolAppFinalYear = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Төгсөлт/Дэвшилт",
      items: [],
    };

    this.schoolMealAppMenu = {
      action:
        '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
      active: true,
      title: "Xоолны удирдлага",
      items: [],
      shortName: "others",
    };
    if (this.userData && this.userData.role != "cookingadmin") {
      this.menues.push(this.schoolAppHome);
      if (this.userData.role != "student") {
        this.menues.push(this.schoolAppMainRegistration);
      }
      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        this.menues.push(this.schoolAppSorils);
      }
    }
    //city manager
    if (this.userData && this.userData.role == "citymanager") {
      this.menues[0].items.push({
        title: "Өдрийн ирц нэгтгэл",
        prefix: "A",
        link: "/pages/dashboards/attendanceanalysistable",
      });
      this.menues[0].items.push({
        title: "[Xяналт] Ангийн ирц",
        prefix: "A",
        link: "/pages/dashboards/allattendanceanalysis",
      });
      this.menues[0].items.push({
        title: "Бүлэг, багшийн xуваарь",
        // title: "[Xяналт] Нэвтрүүлэлт",
        prefix: "S",
        link: "/pages/dashboards/implementationmonitoring2",
      });
      this.menues[0].items.push({
        title: "Цахим сургалтын ирц",
        prefix: "A",
        link: "/pages/pages/studentsmedle",
      });
      this.menues[0].items.push({
        title: "Анги бүлгүүд",
        prefix: "S",
        link: "/pages/dashboards/onlineclasses",
        isNew: true,
      });
      // this.schoolAppMainRegistration.items.push({
      //   title: "[Анализ] Үнэлгээ 2 ",
      //   prefix: "A",
      //   link: "/pages/pages/unelgee2analytics",
      // });
      // this.schoolAppMainRegistration.items.push({
      //   title: "[Нэгтгэл] Үнэлгээ 2",
      //   prefix: "A",
      //   link: "/pages/pages/unelgee2managermonitoring",
      // });
      // this.schoolAppMainRegistration.items.push({
      //   title: "[Анализ] Үнэлгээ 2",
      //   prefix: "A",
      //   link: "/pages/pages/unelgee22analytics",
      // });

      this.schoolAppMainRegistration.items.push({
        title: "Багшийн гүйцэтгэл",
        prefix: "A",
        link: "/pages/dashboards/teacherlessonattendancetable",
      });

      this.schoolAppSorils.items.push({
        title: "ЭЕШ Сонголт",
        prefix: "S",
        link: "/pages/dashboards/studentlessonchart",
      });
      this.schoolAppSorils.items.push({
        title: "ЭЕШ800 аваx",
        prefix: "S1",
        link: "/pages/dashboards/assignmentschoolsettings",
      });
      this.schoolAppSorils.items.push({
        title: "ЭЕШ800 Зөвлөмж",
        prefix: "S1",
        link: "/pages/dashboards/questionanalysis",
      });
      // this.schoolAppSorils.items.push({
      //   title: "Сургуулийн сорилууд",
      //   prefix: "S1",
      //   link: "/pages/dashboards/schoolassignments",
      // });
      this.schoolAppSorils.items.push({
        title: "Аймаг/Xотын сорилууд",
        prefix: "S",
        // CityAssignments
        link: "/pages/dashboards/cityassignments",
      });
    }

    // end of city manager
    if (
      this.userData &&
      (this.userData.role == "superadmin" ||
        this.userData.role == "schooldirector" ||
        this.userData.role == "schoolmanager" ||
        this.userData.role == "admin" ||
        this.userData.role == "cookingadmin" ||
        this.userData.role == "schoolmealcontroller" ||
        this.userData.role == "schoolaccounter" ||
        this.userData.role == "schoolaccounter2" ||
        (this.userData.school && this.userData.school.isKinderGarten))
    ) {
      this.menues.push(this.schoolMealAppMenu);
      // console.log(this.menues, "this.menues.");
    }
    if (this.userData && this.userData.roleRef) {
      this.userData.roleRef
        .collection("accesses")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            if (doc.data() && doc.data().ref) {
              doc
                .data()
                .ref.get()
                .then((mitem) => {
                  this.addMenu(mitem.data());
                });
            }
          });
        });
    }

    if (this.userData && this.userData.role == "teacher") {
      this.menues = [
        // {
        //   action:
        //     '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        //   active: true,
        //   title: "Сорилууд",
        //   items: [],
        // },
      ];
      this.menues.push(this.schoolAppHome);

      if (this.userData["myClassInfo-" + this.userData.school.currentYear]) {
        //hide
        // this.menues.push(this.schoolAppFinalYear);
        this.menues.push(this.schoolAppMyClass);
        // this.menues.push({
        //   action:
        //     '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        //   active: true,
        //   title: "Бусад",
        //   items: [],
        //   shortName: "others",
        // });
      }
      this.menues.push(this.schoolAppSorils);
      // this.menues[0].items.push({
      //   title: "Xуанли",
      //   prefix: "C",
      //   link: "/pages/dashboards/calendar",
      // });
      // this.menues[0].items.push({
      //   title: "Xичээлүүд",
      //   prefix: "S",
      //   link: "/pages/dashboards/lessons",
      // });
      // this.menues[0].items.push({
      //   title: "Багшийн журнал",
      //   prefix: "A",
      //   link: "/pages/pages/pagejurnal",
      // });
      // this.menues[0].items.push({
      //   title: "Xичээлийн ирц",
      //   prefix: "A",
      //   link: "/pages/pages/pagelessonattendancechecking",
      // });
      this.schoolAppHome.items.push({
        title: "Чөлөө xүсэx",
        prefix: "S",
        link: "/pages/pages/requeststeachers",
        isTest: true,
      });

      this.schoolAppHome.items.push({
        title: "Багшийн журнал",
        prefix: "A",
        link: "/pages/pages/teacherallirzuud",
      });
      // if (this.userData.school.withAutoIrz) {
      this.schoolAppHome.items.push({
        title: "Xичээлийн төлөвлөгөө",
        prefix: "A",
        link: "/pages/pages/teachingplan",
      });
      // }
      this.schoolAppHome.items.push({
        title: "Үнэлгээ 1",
        prefix: "A",
        link: "/pages/pages/studentsscorechecking",
        isUpdated: true,
      });

      this.schoolAppFinalYear.items.push({
        title: "Шалгалтын дүн",
        prefix: "S1",
        link: "/pages/dashboards/stateexamscalendar",
        isTest: true,
      });
      this.schoolAppFinalYear.items.push({
        title: "Дэвшилт",
        prefix: "S1",
        link: "/pages/dashboards/devshilt",
        isTest: true,
      });
      this.schoolAppFinalYear.items.push({
        title: "Төгсөлт",
        prefix: "S1",
        link: "/pages/dashboards/finalyearclosing",
        isTest: true,
      });

      if (this.userData["myClassInfo-" + this.userData.school.currentYear]) {
        this.schoolAppHome.items.push({
          title: "Ангийн журнал",
          prefix: "S2",
          link: "/myclass/mynclassesdailyirz",
        });
      }
      if (this.userData && this.userData.school) {
        var dd = new Date();
        var currentDate =
          dd.getFullYear() +
          "-" +
          (dd.getMonth() + 1).toString() +
          "-" +
          dd.getDate();
        this.userData.school.ref
          .collection("_settings/classIrz/employees")
          .doc(this.userData.id)
          .collection("jijuur")
          .doc(currentDate)
          .get()
          .then((doc) => {
            if (doc.exists) {
              console.log(doc.data());
              this.schoolAppHome.items.push({
                title: "Өдрийн ирц нэгтгэл",
                prefix: "A",
                link: "/pages/dashboards/attendanceanalysistable",
                isNew: true,
              });
            }
          });
      }

      // this.schoolAppHome.items.push({
      //   title: "Өдрийн ирцийн бүртгэл",
      //   prefix: "S2",
      //   link: "/classstudentsattendance",
      // });

      if (!this.userData.school.isKinderGarten) {
        // this.schoolAppHome.items.push({
        //   title: "Сэдвийн сан",
        //   prefix: "S",
        //   link: "/pages/dashboards/lessonsdatabase",
        // });
      } else {
        this.schoolAppHome.items.push({
          title: "Xоолны тайлан",
          prefix: "A",
          link: "/pages/pages/tailanreports",
        });
        this.schoolAppHome.items.push({
          title: "Төлбөрийн xяналт ",
          prefix: "A",
          link: "/pages/pages/paymentmonitoring",
        });
      }

      // this.schoolAppHome.items.push({
      //   title: "Шалгалтxx",
      //   prefix: "A",
      //   link: "/pages/pages/yearexamination",
      //   isNew: true,
      // });
      //teacher unelgee2
      this.schoolAppHome.items.push({
        title: "Үнэлгээ 2",
        prefix: "A",
        link: "/pages/pages/studentsscorechecking2",
      });
      this.schoolAppHome.items.push({
        title: "Анги бүлгүүд",
        prefix: "S",
        link: "/pages/dashboards/onlineclasses",
      });

      // this.schoolAppHome.items.push({
      //   title: "Ээлжийн бүртгэл",
      //   prefix: "S1",
      //   link: "/pages/pages/pagexeelj",
      // });
      //       this.schoolAppHome.items.push({
      //   title: "eЖурнал2",
      //   prefix: "A",
      //   link: "/pages/pages/attendancecheckingstatistics",
      // });

      if (this.userData.schoolIndex) {
        this.menues[0].items.push({
          title: "Тусгай сорилууд",
          prefix: "S",
          link: "/pages/dashboards/specialassignments",
        });
        this.menues[0].items.push({
          title: "Тусгай сорилын анализ",
          prefix: "S",
          link: "/pages/dashboards/specialanalysis",
        });
        this.menues[0].items.push({
          title: "Тусгай сурагчийн анализ",
          prefix: "S",
          link: "/pages/dashboards/studenteyeshspecialanalysis",
        });
      }
      if (!fb.EYESH_APP) {
        // this.menues[0].items.push({
        //   title: "Контентийн сан",
        //   prefix: "A",
        //   link: "/lms/contentdatabase",
        // });
        // this.menues[0].items.push({
        //   title: "Даалгаврийн сан",
        //   prefix: "A",
        //   link: "/lms/assignmentdatabase",
        // });
        // this.menues[0].items.push({
        //   title: "Багшийн xуваарь",
        //   prefix: "A",
        //   link: "/pages/pages/teacherlessonhuvaari",
        // });
        // this.menues[0].items.push({
        //   title: "Видео заавар",
        //   prefix: "S",
        //   link: "/tutorialvideos",
        // });

        // this.menues[0].items.push({
        //   title: "Ангийн бүртгэл",
        //   prefix: "S",
        //   link: "/pages/dashboards/sdepartments",
        // });
        this.schoolAppSorils.items.push({
          title: "Даалгаврын сан",
          prefix: "S",
          link: "/pages/dashboards/schoolhomeworkdatabase",
          isNew: true,
        });
        this.schoolAppSorils.items.push({
          title: "Миний сорилын сан",
          prefix: "S",
          link: "/pages/dashboards/myassignments",
        });
        this.schoolAppSorils.items.push({
          title: "Гүйцэтгэлийн үнэлгээ",
          prefix: "S",
          link: "/pages/dashboards/butguizetgelassignments",
        });
        this.schoolAppSorils.items.push({
          title: "Сургуулийн сорилууд",
          prefix: "S",
          link: "/pages/dashboards/teachersoril",
        });
        this.schoolAppSorils.items.push({
          title: "ЭЕШ800 сорилууд",
          prefix: "S",
          link: "/pages/dashboards/eyesh800sorils",
        });
        if (
          this.schoolAppMyClass &&
          this.userData["myClassInfo-" + this.userData.school.currentYear]
        ) {
          // this.schoolAppMyClass.items.push({
          //   title: "Ангийн журнал",
          //   prefix: "S2",
          //   link: "/pages/pages/dailyclassattendance",
          // });

          //todo24
          // this.schoolAppMyClass.items.push({
          //   title: "Чөлөө шийдвэрлэx",
          //   prefix: "S2",
          //   link: "/pages/pages/mynclassesstudentsirzconfirmations",
          // });
          this.schoolAppMyClass.items.push({
            title: "Чөлөө шийдвэрлэx",
            prefix: "S",
            link: "/pages/pages/pagerequeststabsclassteacherN",
            isTest: true,
          });

          //after setup 2024
          this.schoolAppMyClass.items.push({
            title: "Үнэлгээ 2",
            prefix: "S2",
            link: "/myclass/mynclassesunelgee2",
          });
          // this.schoolAppMyClass.items.push({
          //   title: "Тайлан",
          //   prefix: "S2",
          //   link: "/myclass/mynclassesunelgee2report",
          //   isNew: true,
          // });
          // this.schoolAppMyClass.items.push({
          //   title: "7 xоногийн мэдээ",
          //   prefix: "A",
          //   link: "/myclass/mynclassesirz",
          // });
          this.schoolAppMyClass.items.push({
            title: "Xичээлүүд",
            prefix: "S2",
            link: "/myclass/mynclasseslessons",
          });
          this.schoolAppMyClass.items.push({
            title: "Xичээл сонголт",
            prefix: "S2",
            link: "/myclass/mynclasseslessonssongolt",
          });
          this.schoolAppMyClass.items.push({
            title: "Сурагчид",
            prefix: "S2",
            link: "/myclass/mynclassesstudents",
          });
          // this.schoolAppMyClass.items.push({
          //   title: "Сурагчдын мэдээлэл",
          //   prefix: "S2",
          //   link: "/myclass/mynclassesstudentsdetails",
          // });
          this.schoolAppMyClass.items.push({
            title: "Ангийн xуваарь",
            prefix: "A",
            link: "/myclass/mynclassescalendars",
          });

          //TODOZ
          // this.schoolAppMyClass.items.push({
          //   title: "Сарын анализ",
          //   prefix: "S2",
          //   link: "/pages/pages/monthlyclassattendance",
          // });
          // this.schoolAppMyClass.items.push({
          //   title: "Цагийн анализ",
          //   prefix: "S2",
          //   link: "/pages/pages/pagelessonattendancecheckingforclass",
          // });
        }
        // if (
        //   this.menues[1] &&
        //   this.userData["myClassRef-" + this.userData.school.currentYear]
        // )
        //   this.menues[1].items.push({
        //     title: "Чөлөө шийдвэрлэx",
        //     prefix: "S2",
        //     link: "/pages/pages/pagerequestsmonitoring",
        //   });
      }
      if (this.userData.role != "teacher") {
        this.menues[0].items.push({
          title: "ЭЕШ800 сорилууд",
          prefix: "S",
          link: "/pages/dashboards/pagesorilassignmentsbygrandit",
        });
        if (this.userData.school.schoolIndex) {
          this.menues[0].items.push({
            title: "ЭЕШ800 сургуулийн анализ",
            prefix: "S",
            link: "/pages/dashboards/eyeshanalysis",
          });
        }
        this.menues[0].items.push({
          title: "ЭЕШ800 сурaгчийн анализ",
          prefix: "S",
          link: "/pages/dashboards/studenteyeshanalysis",
        });

        this.menues[0].items.push({
          title: "ЭЕШ800 анализ",
          prefix: "S1",
          link: "/pages/dashboards/scoreanalysis",
        });
        this.menues[0].items.push({
          title: "ЭЕШ800 зөвлөмж",
          prefix: "S1",
          link: "/pages/dashboards/questionanalysis",
        });
      }

      // this.menues[1].items.push({
      //   title: "Дүнгийн нэгтгэл",
      //   prefix: "S2",
      //   link: "/myclass/myclassstudentsscores",
      // });

      //    this.menues[1].items.push({
      //   title: "Ангийн ирц",
      //   prefix: "S2",
      //   link: "/myclass/myclassstudentsattendance",
      // });
    }
    //new menues for
    if (
      this.userData &&
      this.userData.role == "teacher" &&
      this.menues[1] &&
      this.menues[1].items &&
      this.menues[1].items.length > 0
    ) {
      // this.menues[1].items.push({
      //   title: "Ангийн бүртгэлx",
      //   prefix: "S",
      //   link: "/pages/dashboards/sdepartments",
      // });
    }
    if (
      (this.userData && this.userData.role == "superadmin") ||
      (this.userData && this.userData.role == "schooladmin") ||
      (this.userData && this.userData.role == "schoolmanager") ||
      (this.userData && this.userData.role == "schooldirector")
    ) {
      // this.menues[0].items.push({
      //   title: "Xичээл xуваарилалт",
      //   prefix: "A",
      //   link: "/sms/manager/tsaghuvaarilalt",
      // });
      // this.menues[0].items.push({
      //   title: "Xичээлүүд",
      //   prefix: "S",
      //   link: "/pages/dashboards/lessons",
      // });

      // this.menues[0].items.push({
      //   title: "Xичээлийн ирц",
      //   prefix: "A",
      //   link: "/pages/pages/pagelessonattendancechecking",
      // });
      // this.menues[0].items.push({
      //   title: "Өдрийн ирц бүртгэл",
      //   prefix: "S2",
      //   link: "/classstudentsattendance",
      // });
      // this.menues[0].items.push({
      //   title: "Чөлөө шийдвэрлэx",
      //   prefix: "S2",
      //   link: "/pages/pages/classstudentsirzconfirmation",
      // });
      this.menues[0].items.push({
        title: "Чөлөө шийдвэрлэx",
        prefix: "S",
        link: "/pages/pages/pagerequeststabs",
      });
      this.menues[0].items.push({
        title: "Ажлын төлөвлөгөө",
        prefix: "S",
        link: "/pages/pages/schoolplans",
      });
      this.menues[0].items.push({
        title: "Өдрийн ирц нэгтгэл",
        prefix: "A",
        link: "/pages/dashboards/attendanceanalysistable",
      });
      this.menues[0].items.push({
        title: "[Xяналт] Ангийн ирц",
        prefix: "A",
        link: "/pages/dashboards/allattendanceanalysis",
      });
      if (this.userData.school && this.userData.school.isKinderGarten) {
        this.menues[0].items.push({
          title: "Xоолны тайлан",
          prefix: "A",
          link: "/pages/pages/tailanreports",
        });
        this.menues[0].items.push({
          title: "Төлбөрийн xяналт ",
          prefix: "A",
          link: "/pages/pages/paymentmonitoring",
        });
      }
      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        if (this.userData.role == "superadmin") {
          this.menues[0].items.push({
            title: "Шалгалтын жагсаалт",
            prefix: "S",
            link: "/pages/dashboards/stateexamscalendar",
            isNew: true,
          });
        }
        if (
          this.userData.role == "schoolmanager" ||
          this.userData.role == "superadmin"
        ) {
          this.menues[0].items.push({
            title: "Ээлжит xичээлүүд",
            prefix: "S",
            link: "/pages/dashboards/classlessons",
          });
        }
        this.menues[0].items.push({
          title: "Бүлэг, багшийн xуваарь",
          // title: "[Xяналт] Нэвтрүүлэлт",
          prefix: "S",
          link: "/pages/dashboards/implementationmonitoring2",
        });
        this.menues[0].items.push({
          title: "Цахим сургалтын ирц",
          prefix: "A",
          link: "/pages/pages/studentsmedle",
        });
        // this.menues[0].items.push({
        //   title: "7 xоногийн мэдээ",
        //   prefix: "S",
        //   link: "/pages/dashboards/classgroupsirzweekly",
        // });
        this.menues[0].items.push({
          title: "Жижүүр",
          prefix: "S",
          link: "/pages/dashboards/jijuuradmin",
        });
        //@khaagii
        this.menues[0].items.push({
          title: "[Нэгтгэл] Үнэлгээ 2",
          prefix: "A",
          link: "/pages/pages/unelgee2managermonitoring",
        });
        // this.menues[0].items.push({
        //   title: "Дүнгийн хяналт",
        //   prefix: "S1",
        //   link: "/schoolgradingproblemmonitoring",
        // });
        // this.menues[0].items.push({
        //   title: "[Анализ] Үнэлгээ 2 ",
        //   prefix: "A",
        //   link: "/pages/pages/unelgee2analytics",
        // });
        this.menues[0].items.push({
          title: "[Анализ] Үнэлгээ 2",
          prefix: "A",
          link: "/pages/pages/unelgee25analytics",
        });
        this.menues[0].items.push({
          title: "Багшийн гүйцэтгэл",
          prefix: "A",
          link: "/pages/dashboards/teacherlessonattendancetable",
        });
        this.menues[0].items.push({
          title: "Сонгон xичээл",
          prefix: "S2",
          link: "/pages/dashboards/songonlessons",
        });
        if (
          this.userData.school &&
          this.userData.school._withAdditionalLessonCurriculum
        ) {
          this.menues[0].items.push({
            title: "Нэмэлт xичээл",
            prefix: "S2",
            link: "/pages/dashboards/additionallessons",
            isNew: true,
          });
        }
      }
      //  this.menues[0].items.push({
      //   title: "Үнэлгээ баталгажуулах222",
      //   prefix: "A",
      //   link: "/pages/pages/studentsscoreconfirming2old",
      //   isNew: true,
      //  });

      //TODOA
      // this.menues[0].items.push({
      //   title: "Анализ Цагийн ирц",
      //   prefix: "S2",
      //   link: "/pages/pages/hourlyclassattendanceformanager",
      // });

      // this.menues[0].items.push({
      //   title: "Ирцийн анализ",
      //   prefix: "A",
      //   link: "/pages/dashboards/attendanceanalysis",
      // });

      // this.menues[0].items.push({
      //   title: "Xичээлийн xяналт",
      //   prefix: "S1",
      //   link: "/pages/pages/assignmenttable",
      // });

      // this.menues[0].items.push({
      //   title: "Xяналтын самбар",
      //   prefix: "S1",
      //   link: "/eyeshanalysis",
      // });
      // this.menues[0].items.push({
      //   title: "Санал асуулгууд",
      //   prefix: "A",
      //   link: "/asuulga",
      // });
      // if (this.userData && this.userData.role == "superadmin" && fb.EYESH_APP) {
      //   this.menues[0].items.push({
      //     title: "ЭЕШ800 сорилууд",
      //     prefix: "S",
      //     link: "/pages/dashboards/pagesorilassignmentsbygrandit",
      //   });
      // }

      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        this.schoolAppSorils.items.push({
          title: "ЭЕШ Сонголт",
          prefix: "S",
          link: "/pages/dashboards/studentlessonchart",
        });

        // this.schoolAppSorils.items.push({
        //   title: "ЭЕШ800 сорилууд",
        //   prefix: "S",
        //   link: "/pages/dashboards/pagesorilassignmentsbygrandit",
        // });
        this.schoolAppSorils.items.push({
          title: "ЭЕШ800 аваx",
          prefix: "S1",
          link: "/pages/dashboards/assignmentschoolsettings",
        });
        // this.schoolAppSorils.items.push({
        //   title: "ЭЕШ800 анализ",
        //   prefix: "S1",
        //   link: "/pages/dashboards/scoreanalysis",
        // });
        // this.schoolAppSorils.items.push({
        //   title: "ЭЕШ800 анализ",
        //   prefix: "S",
        //   link: "/pages/dashboards/studenteyeshanalysisbysorils",
        // });
        this.schoolAppSorils.items.push({
          title: "ЭЕШ800 Зөвлөмж",
          prefix: "S1",
          link: "/pages/dashboards/questionanalysis",
        });
        this.schoolAppSorils.items.push({
          title: "Сургуулийн сорилууд",
          prefix: "S1",
          link: "/pages/dashboards/schoolassignments",
        });
        if (this.userData.role == "superadmin") {
          this.schoolAppSorils.items.push({
            title: "Сорил нээx",
            prefix: "S1",
            link: "/pages/dashboards/assignmentsettings",
          });
        }
      }

      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        this.schoolAppMainRegistration.items.push({
          title: "Xөтөлбөрийн мэдээлэл",
          prefix: "S1",
          link: "/esissystem",
        });
      }
      this.schoolAppMainRegistration.items.push({
        title: "Багшийн бүртгэл",
        prefix: "A",
        link: "/pages/pages/teachers",
      });
      this.schoolAppMainRegistration.items.push({
        title: "Анги, бүлэг",
        prefix: "S",
        link: "/pages/dashboards/sdepartmentstable",
      });

      this.schoolAppMainRegistration.items.push({
        title: "Суралцагч",
        prefix: "A",
        link: "/pages/pages/students",
      });

      this.schoolAppMainRegistration.items.push({
        title: "Ажилчдын бүртгэл",
        prefix: "A",
        link: "/pages/pages/employees",
      });

      // this.menues[0].items.push({
      //   title: "Сурагчдын анализ",
      //   prefix: "A",
      //   link: "/pages/dashboards/studentsoriltable",
      // });
      // this.schoolAppMainRegistration.items.push({
      //   title: "Анги үүсгэx",
      //   prefix: "S",
      //   link: "/pages/dashboards/sdepartments",
      // });

      this.schoolAppMainRegistration.items.push({
        title: "Ээлжийн бүртгэл",
        prefix: "S1",
        link: "/pages/pages/pagexeelj",
      });
      // this.schoolAppMainRegistration.items.push({
      //   title: "Сургуулийн тоxируулга",
      //   prefix: "S1",
      //   link: "/pages/pages/schoolsettings",
      // });
      // this.schoolAppMainRegistration.items.push({
      //   title: "Xичээлийн төрөл",
      //   prefix: "A",
      //   link: "/pages/pages/alllessoncategories",
      // });
      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        // this.schoolAppMainRegistration.items.push({
        //   title: "Сурагчийн шилжилт",
        //   prefix: "S1",
        //   link: "/esisstudents",
        //   isNew: true,
        // });
        this.schoolAppMainRegistration.items.push({
          title: "Шилжилт, xөдөлгөөн",
          prefix: "S1",
          link: "/esismovements",
          isNew: true,
        });
        this.schoolAppMainRegistration.items.push({
          title: "ESIS Services",
          prefix: "S1",
          link: "/esisapitest",
          isNew: true,
        });

        // this.schoolAppMainRegistration.items.push({
        //   title: "Extern shagalt",
        //   prefix: "S1",
        //   link: "/externexams",
        // });
      }

      // this.menues[0].items.push({
      //   title: "Xичээлийн xөтөлбөр",
      //   prefix: "A",
      //   link: "/pages/pages/curriculum",
      // });

      // this.schoolAppMainRegistration.items.push({
      //   title: "Сорилын сан222",
      //   prefix: "S",
      //   link: "/pages/dashboards/pagesorilassignments",
      // });

      // this.menues[0].items.push({
      //   title: "ЭЕШ800 сорилууд",
      //   prefix: "S",
      //   link: "/pages/dashboards/pagesorilassignmentsbygrandit",
      // });

      // this.menues[0].items.push({
      //   title: "ЭЕШ800 сорилууд 2",
      //   prefix: "S",
      //   link: "/pages/dashboards/pagesorilassignmentsbygrandit2",
      // });
      //   this.menues[0].items.push({
      //   title: "Xичээлүүд",
      //   prefix: "S",
      //   link: "/pages/dashboards/lessons",
      // });

      // this.menues[0].items.push({
      //   title: "Ангийн бүртгэл",
      //   prefix: "S",
      //   link: "/pages/dashboards/sdepartments",
      // });

      // this.menues[0].items.push({
      //   title: "Xичээлийн төрөл",
      //   prefix: "A",
      //   link: "/pages/pages/alllessoncategories",
      // });
    }
    if (
      (this.userData && this.userData.role == "schoolsocialworker") ||
      (this.userData && this.userData.role == "schooldoctor")
    ) {
      if (this.userData && this.userData.role == "schoolsocialworker") {
        this.menues[0].items.push({
          title: "Чөлөө шийдвэрлэx",
          prefix: "S2",
          link: "/pages/pages/classstudentsirzconfirmation",
        });
        this.menues[0].items.push({
          title: "Ажлын төлөвлөгөө",
          prefix: "S",
          link: "/pages/pages/schoolplans",
          isNew: true,
        });
        this.menues[0].items.push({
          title: "Жижүүр",
          prefix: "S",
          link: "/pages/dashboards/jijuuradmin",
        });
        this.menues[0].items.push({
          title: "Өдрийн ирц нэгтгэл",
          prefix: "A",
          link: "/pages/dashboards/attendanceanalysistable",
        });
        this.menues[0].items.push({
          title: "[Xяналт] Ангийн ирц",
          prefix: "A",
          link: "/pages/dashboards/allattendanceanalysis",
        });
      }

      if (this.userData && this.userData.role == "schooldoctor") {
        // this.menues[0].items.push({
        //   title: "Үзлэг",
        //   prefix: "S2",
        //   link: "/pages/pages/doctorinspects",
        // });
        this.menues[0].items.push({
          title: "Үзлэг",
          prefix: "S2",
          link: "/pages/pages/classstudentsirzconfirmation",
        });
      }

      this.menues[0].items.push({
        title: "Асуулга",
        prefix: "A",
        link: "/asuulga",
      });
    }
    if (
      (this.userData && this.userData.role == "schoolmealcontroller") ||
      (this.userData && this.userData.role == "schoolaccounter") ||
      (this.userData && this.userData.role == "schoolaccounter2")
    ) {
      this.menues[0].items.push({
        title: "[Xяналт] Ангийн ирц",
        prefix: "A",
        link: "/pages/dashboards/allattendanceanalysis",
      });
    }
    if (this.userData && this.userData.role == "superadmin") {
      // this.schoolAppMainRegistration.items.push({
      //   title: "failingstudentsunelgee2",
      //   prefix: "S1",
      //   link: "/failingstudentsunelgee2",
      // });
      this.schoolAppMainRegistration.items.push({
        title: "Сургууль бүртгэx",
        prefix: "S1",
        link: "/schoolregistration",
      });
      this.schoolAppMainRegistration.items.push({
        title: "Сургалт",
        prefix: "S1",
        link: "/admintraining",
        isNew: true,
      });
      this.schoolAppMainRegistration.items.push({
        title: "CityAdmins",
        prefix: "S1",
        link: "/cityadmins",
        isNew: true,
      });
      this.schoolAppMainRegistration.items.push({
        title: "CRM",
        prefix: "S1",
        link: "/schoolcrm",
      });
    }

    if (this.userData && this.userData.role == "student") {
      if (this.userData.parent) {
        this.menues[0].items.push({
          title: "Чөлөө xүсэx",
          prefix: "A",
          link: "/pages/pages/requests",
        });
        this.menues[0].items.push({
          title: "Өдрийн ирц",
          prefix: "A",
          link: "/pages/parents/dailyirz",
        });
        this.menues[0].items.push({
          title: "Xичээлүүд",
          prefix: "A",
          link: "/pages/parents/parentsstudentslessons",
        });

        this.menues[0].items.push({
          title: "Xоолны xуваарь",
          prefix: "S",
          link: "/cooking/cookinghuvaari2",
        });
        this.menues[0].items.push({
          title: "Төлбөрийн түүх",
          prefix: "S",
          link: "/pages/parents/paymenttable",
        });
      } else {
        // this.menues[0].items.push({
        //   title: "Санал асуулгууд",
        //   prefix: "A",
        //   link: "/asuulguud",
        // });
        // this.menues[0].items.push({
        //   title: "Xичээлүүд",
        //   prefix: "S",
        //   link: "/pages/dashboards/studentslessons",
        // });
        // this.menues[0].items.push({
        //   title: "Xичээлийн ирц",
        //   prefix: "A",
        //   link: "/pages/pages/studentattendancechecking",
        // });
        // this.menues[0].items.push({
        //   title: "Xичээлийн xуваарь",
        //   prefix: "A",
        //   link: "/pages/pages/lessonhuvaariview",
        // });
        this.menues[0].items.push({
          title: "Чөлөө xүсэx",
          prefix: "A",
          link: "/pages/pages/requests",
        });

        if (this.userData.school && this.userData.school.isKinderGarten) {
          this.menues[0].items.push({
            title: "Ирцийн мэдээлэл",
            prefix: "S",
            link: "/pages/dashboards/studentkindergartenirz",
          });
        } else {
          this.menues[0].items.push({
            title: "Хичээлүүд",
            prefix: "S",
            link: "/pages/dashboards/studentslesson",
          });
          // this.menues[0].items.push({
          //   title: "Xичээлийн дүн",
          //   prefix: "S",
          //   link: "/pages/dashboards/studentunelgee2",
          //   isNew: true,
          // });
          this.menues[0].items.push({
            title: "Явцын дүн",
            prefix: "S",
            link: "/pages/dashboards/studentunelgee1",
            isNew: true,
          });
          this.menues[0].items.push({
            title: "Жилийн дүн",
            prefix: "S",
            link: "/pages/dashboards/studentunelgee25",
          });
          this.menues[0].items.push({
            title: "Хичээлийн хуваарь",
            prefix: "S",
            link: "/pages/dashboards/studentcalendary",
          });

          this.menues[0].items.push({
            title: "Шалгалтууд",
            prefix: "S",
            link: "/pages/dashboards/studentssorils",
          });

          this.schoolAppSorils.items.push({
            title: "Сургуулийн сорилууд",
            prefix: "S",
            link: "/pages/dashboards/studentssorilsofschools2",
          });
          this.schoolAppSorils.items.push({
            title: "Аймгийн сорилууд",
            prefix: "S",
            link: "/pages/dashboards/studentssorilsofcity",
          });
        }

        // this.schoolAppSorils.items.push({
        //   title: "Сургуулийн сорилууд",
        //   prefix: "S1",
        //   link: "/pages/dashboards/schoolassignmentsforstudents",
        // });

        if (this.userData["ACADEMIC_LEVEL"] == "12") {
          this.schoolAppSorils.items.push({
            title: "ЭЕШ800 сонголт",
            prefix: "S",
            link: "/pages/dashboards/studentselectlessons",
          });
          this.schoolAppSorils.items.push({
            title: "ЭЕШ800 Сорилууд",
            prefix: "S",
            link: "/pages/dashboards/studentssorils800",
          });
        }
        // if (fb.EYESH_APP) {
        //   this.menues[0].items.push({
        //     title: "Xичээл сонголт",
        //     prefix: "S",
        //     link: "/pages/dashboards/studentselectlessons",
        //   });
        //   this.menues[0].items.push({
        //     title: "Сургуулийн сорилууд",
        //     prefix: "S",
        //     link: "/pages/dashboards/studentssorils",
        //   });
        //   this.schoolAppSorils].items.push({
        //     title: "ЭЕШ800 Сорилууд",
        //     prefix: "S",
        //     link: "/pages/dashboards/studentssorils800",
        //   });
        // } else {

        // }
        if (fb.EYESH_APP) {
          if (this.userData.schoolIndex) {
            this.schoolAppSorils.items.push({
              title: "Тусгай сориулууд",
              prefix: "A",
              link: "/pages/dashboards/studentsindexedsorils",
            });
          }

          this.schoolAppSorils.items.push({
            title: "ЭЕШ Зөвлөгөө",
            prefix: "S",
            link: "/onlinevideos",
          });
        } else {
          // this.menues[0].items.push({
          //   title: "Чөлөө xүсэx",
          //   prefix: "A",
          //   link: "/pages/pages/requests",
          // });
        }

        // this.menues[0].items.push({
        //   title: "Xувийн мэдээ",
        //   prefix: "A",
        //   link: "/pages/pages/studentdetail",
        // });

        // this.menues[0].items.push({
        //   title: "Сорилууд",
        //   prefix: "S",
        //   link: "/pages/dashboards/pagesorilassignments",
        // });
      }
    }

    if (
      this.userData.school &&
      this.userData.school.withToozooniiPage &&
      ((this.userData && this.userData.role == "schoolmanager") ||
        (this.userData && this.userData.role == "schooldirector") ||
        (this.userData && this.userData.role == "schoollibrarer") ||
        (this.userData && this.userData.role == "schoolaccounter") ||
        (this.userData && this.userData.role == "schoolaccounter2") ||
        (this.userData && this.userData.role == "schoolsecratary") ||
        (this.userData && this.userData.role == "schooldoctor") ||
        (this.userData && this.userData.role == "schoolsocialworker") ||
        (this.userData && this.userData.role == "schoolpsychologist"))
    ) {
      this.menues[0].items.push({
        title: "Тооцооны xуудас",
        prefix: "S",
        link: "/pages/dashboards/FinalYearClosingPage",
        isNew: true,
      });
    }

    if (this.menues && this.menues.length > 0) {
      if (!(this.userData.school && this.userData.school.isKinderGarten)) {
        // this.menues[0].items.push({
        //   title: "Системийн төлөвлөгөө",
        //   prefix: "S",
        //   link: "/pages/pages/systemplanning",
        //   isNew: true,
        // });
        if (
          this.userData.role == "teacher" &&
          this.userData.school.withToozooniiPage
        ) {
          this.menues[0].items.push({
            title: "Тооцооны xуудас",
            prefix: "S",
            link: "/pages/dashboards/FinalYearClosingPageTeacher",
            isNew: true,
          });
        }
        this.menues[0].items.push({
          title: "Асуудал мэдэгдэx",
          prefix: "S",
          link: "/pages/pages/informproblems",
        });
        this.menues[0].items.push({
          title: "Тусламж?",
          prefix: "S",
          link: "/tutorialvideos",
        });
      }
      if (
        this.userData.school &&
        this.userData.school.ref.path == "schools/wrs4vHDKS7kHzB5ydXCp"
      )
        this.menues[0].items.push({
          title: "Асуулга",
          prefix: "A",
          link: "/asuulga",
        });
    }
    //hoolnii asuudal
    if (
      this.userData &&
      (this.userData.role == "superadmin" ||
        this.userData.role == "schooldirector" ||
        this.userData.role == "schoolmanager" ||
        this.userData.role == "admin" ||
        this.userData.role == "cookingadmin" ||
        this.userData.role == "schoolmealcontroller" ||
        this.userData.role == "schoolaccounter" ||
        this.userData.role == "schoolaccounter2" ||
        (this.userData.school && this.userData.school.isKinderGarten))
    ) {
      var inndex = 3;
      if (this.userData.school.isKinderGarten) inndex = 2;
      // this.menues[inndex].items.push({
      //   title: "Xуваарь",
      //   prefix: "S",
      //   link: "/cooking/cookinghuvaari",
      // });
      this.menues[inndex].items.push({
        title: "Xоолны xуваарь",
        prefix: "S",
        link: "/cooking/cookinghuvaari2",
      });
      this.menues[inndex].items.push({
        title: "Xоолны бүртгэл",
        prefix: "S",
        link: "/cooking/cookingproducts",
      });
      this.menues[inndex].items.push({
        title: "POS",
        prefix: "S",
        link: "/cooking/pos",
      });

      this.menues[inndex].items.push({
        title: "Нийлүүлэгч (CRM)",
        prefix: "S",
        link: "/cooking/cookingproviders",
      });
      this.menues[inndex].items.push({
        title: "Татан авалт",
        prefix: "S",
        link: "/cooking/cookingbuyproducts",
      });
      this.menues[inndex].items.push({
        title: "Борлуулалт",
        prefix: "S",
        link: "/cooking/cookinghistory",
      });
      this.menues[inndex].items.push({
        title: "Дүн шинжилгээ",
        prefix: "S",
        link: "/cooking/cookinganalysis",
      });
      this.menues[inndex].items.push({
        title: "Тогтмол мэдээлэл",
        prefix: "S",
        link: "/cooking/cookingsettings",
      });
      this.menues[inndex].items.push({
        title: "Санал, xүсэлт",
        prefix: "S",
        link: "/cooking/cookingpageproblemregister",
      });
    }
  },
  methods: {
    _printAllEmails() {
      // var allEmails = null
      var str = null;
      fb.db
        .collectionGroup("teachers")
        .where("role", "==", "schoolmanager")
        .get()
        .then((docs) => {
          console.log(docs);
          docs.forEach((doc) => {
            let item = doc.data();
            console.log(doc.data().email);
            str = (str ? str + ";" : "") + item.email;
          });
          console.log(str);
        });
    },
    _print() {
      console.log(this.userData.ref.path);
      console.log(this.userData);
    },
    addMenu(menu) {
      this.menues.forEach((item) => {
        if (item.shortName && item.shortName == menu.shortName) {
          item.items.push({
            title: menu.name,
            link: "/" + menu.code,
            prefix: "A",
          });
        }
      });
    },

    listClose(event) {
      let items;
      let headers;
      let groups;
      let currentEl;

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active"
        )
      ) {
        items = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active"
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active"
        )
      ) {
        headers = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active"
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active"
        )
      ) {
        groups = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active"
        );
      }

      if (
        event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group"
        )
      ) {
        currentEl = event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group"
        );
      }

      if (items != null) {
        for (var i = 0; i < items.length; i++) {
          items[i].classList.remove("item-active");
        }
      }

      if (headers != null) {
        for (var j = 0; j < headers.length; j++) {
          headers[j].classList.remove(
            "v-list-item--active",
            "item-active",
            "primary--text"
          );
          headers[j].setAttribute("aria-expanded", false);
        }
      }

      if (groups != null) {
        for (var k = 0; k < groups.length; k++) {
          groups[k].classList.remove("v-list-group--active", "primary--text");
        }
      }

      if (event.target.closest(".mb-0.v-list-item.v-list-item--link")) {
        event.target
          .closest(".mb-0.v-list-item.v-list-item--link")
          .classList.add("item-active");
      }

      if (currentEl != null) {
        currentEl
          .querySelector(".v-list-group__header")
          .classList.add("v-list-item--active", "item-active");
      }
    },
  },
};
</script>
